import * as z from "zod";

export const TEAM_CALENDAR_ENTRY_TITLE_MAX_LENGTH = 200;
export const TEAM_CALENDAR_ENTRY_DESCRIPTION_MAX_LENGTH = 1000;

/** Every agenda item reaches the Commerce Agent's prompt, so the agenda stays small. */
export const TEAM_CALENDAR_ENTRY_MAX_AGENDA_ITEMS = 20;

export const TEAM_CALENDAR_ENTRY_MAX_AGENDA_OPERATIONS = 50;

/** Control characters and line breaks; a title is one line, so only tab is allowed. */
const TITLE_CONTROL_CHARACTERS =
  /[\u0000-\u0008\u000A-\u001F\u007F\u0085\u2028\u2029]/;

/** Control characters other than tab and line breaks. */
export const TEXT_CONTROL_CHARACTERS =
  /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/;

export const teamCalendarEntryTitleSchema = z
  .string()
  .trim()
  .min(1)
  .max(TEAM_CALENDAR_ENTRY_TITLE_MAX_LENGTH)
  .refine((value) => !TITLE_CONTROL_CHARACTERS.test(value), {
    message: "Must not contain control characters or line breaks",
  });

export const teamCalendarEntryDescriptionSchema = z
  .string()
  .trim()
  .max(TEAM_CALENDAR_ENTRY_DESCRIPTION_MAX_LENGTH)
  .refine((value) => !TEXT_CONTROL_CHARACTERS.test(value), {
    message: "Must not contain control characters",
  });
